import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import apiService from 'common/services/api/apiService';
import FetchStatus from 'common/types/FetchStatus';
import { Paginated } from 'common/types/Paginated';
import { AppThunk } from 'configureStore';
import { License } from 'domain/types/License';
import queryString from 'querystring';

type VacationRentalsState = {
  entities: {
    [key: string]: License;
  };
  meta: {
    currentPageIds: number[];
    fetchStatus: FetchStatus;
    pagination: Paginated;
  };
};

export const initialState: VacationRentalsState = {
  entities: {},
  meta: {
    currentPageIds: [],
    fetchStatus: FetchStatus.none,
    pagination: {
      totalPages: 0,
      totalCount: 0,
      currentPage: 0,
      itemsPerPage: 10,
    },
  },
};

const LicensesSlice = createSlice({
  name: 'Licenses',
  initialState,
  reducers: {
    fetchLicensesStart(state) {
      state.meta.fetchStatus = FetchStatus.loading;
      return state;
    },
    fetchLicensesSucccess(
      state,
      action: PayloadAction<Paginated<{ licenses: License[] }>>
    ) {
      state.meta.fetchStatus = FetchStatus.loaded;
      state.meta.currentPageIds = [];
      for (const app of action.payload.licenses) {
        state.entities[app.id] = app;
        state.meta.currentPageIds.push(app.id);
      }
      state.meta.pagination = {
        currentPage: action.payload.currentPage,
        itemsPerPage: action.payload.itemsPerPage,
        totalCount: action.payload.totalCount,
        totalPages: action.payload.totalPages,
      };
      return state;
    },
    getLicensesSuccess(state, action: PayloadAction<{ license: License }>) {
      const { license } = action.payload;
      state.entities[license.id] = license;
      return state;
    },
  },
});

export function fetchSubmittedLicenses(
  pagination: { page: number; items: number } | null = null
): AppThunk<Promise<void>> {
  return async function (dispatch, getState) {
    dispatch(LicensesSlice.actions.fetchLicensesStart());

    const {
      auth: { access_token },
    } = getState();

    let error;

    try {
      const query = pagination
        ? '?' +
          queryString.stringify({
            pageNum: pagination.page,
            pageSize: pagination.items,
          })
        : '';
      const res = await apiService.get(`/vrbb${query}`, access_token);
      if (res.ok) {
        const pagedLicenses = await res.json();
        dispatch(LicensesSlice.actions.fetchLicensesSucccess(pagedLicenses));
        return Promise.resolve();
      }
      error = await res.json();
    } catch (e: any) {
      error = e.toString();
    }

    return Promise.reject(error);
  };
}

export const { getLicensesSuccess } = LicensesSlice.actions;

export default LicensesSlice.reducer;
